/**
 * Shares the founder's data-room category list app-wide.
 *
 * The active DataRoom page populates `categories`; the Navbar reads them to
 * render the data-room sub-menu. State only — no fetching happens here.
 */
import React, { createContext, useContext, useState } from 'react';

const DataRoomContext = createContext({ categories: [], setCategories: () => {} });

/** Provider that holds the current data-room category list in state. */
export function DataRoomProvider({ children }) {
  const [categories, setCategories] = useState([]);
  return (
    <DataRoomContext.Provider value={{ categories, setCategories }}>
      {children}
    </DataRoomContext.Provider>
  );
}

/** Hook to read/replace the shared data-room categories. */
export function useDataRoom() {
  return useContext(DataRoomContext);
}
